// NEEDS TO MATCH SCSS BREAKPOINTS
export const BREAKPOINTS = {
  SM: 480,
  MD: 768,
  LG: 1024,
  XL: 1200,
  XXL: 1400,
};
